export default __webpack_public_path__ + "static/media/changes.ed2b3867.svg";